<template>
  <div style=" 
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index:3"
    :style="{ backgroundColor: bg }">

    <v-container grid-list-xl>
       <v-layout
             flex-child
             wrap
             class="justify-center"
             style="margin-bottom:-8vh"
           >  
             <v-flex
               xs12
               md6
               d-flex
             >
             
           </v-flex>
         </v-layout>

      <v-layout
        flex-child
        wrap
        class="justify-center"
        style="padding-top:8vh"
      >  
        
        
        <v-flex
          xs12
          md10
          d-flex
        >
          <v-layout wrap>
       
            <v-flex   xs6 md3>
              <v-sheet
                class="d-flex"
                style="border-radius:30px; "
               
                height="150"
                width="150"
              >
                <img height="150px" src="../assets/contractTabSelect/token.png"/>
                 
              </v-sheet>
            </v-flex>
             <h4 v-if="$vuetify.breakpoint.smAndDown" style="position:absolute;top:0px; right:0px;"> <span style="margin-right:30px; font-weight:600;">{{contractType.name}}</span> <v-btn class="text-capitalize" dark color="green" @click="goToDetail()" style="float:right;">Use template</v-btn></h4>
            <v-flex xs6 md8>
              <h4 v-if="!$vuetify.breakpoint.smAndDown" style="display:block"> {{contractType.name}} <v-btn class="text-capitalize" dark color="green" @click="goToDetail()" style="float:right;">Use template</v-btn></h4>
              
              <v-sheet
                class="d-flex"
                style="border-radius:30px;  "
                color=""
                height="160"
              >
               
              <p v-html="contractType.desc" style="padding:10px">{{contractType.desc}}</p>

              </v-sheet>

            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          xs12
          md10
          d-flex
        >
          <v-layout wrap>
       
            <v-flex xs6 md3>
              <v-sheet
                class="d-flex"
                style="border-radius:30px;  "
                
                height="160"
              >
                <v-list subheader>
                 <v-subheader>Contract features</v-subheader>
                 <v-list-tile    
                    
                   @click=""
                   v-for="(feature, index) in  contractType.features"
                 >
                    
                   <v-list-tile-content>
                     <span style="font-size:12px">{{feature}}</span>
                   </v-list-tile-content>
                 </v-list-tile>
               </v-list>
              </v-sheet>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
     
    </v-container>
    
    <div style="position:fixed; top:40px; left:40px; width:40px; height:40px">
      <v-btn to="/contractTemplates" round flat style="font-weight:600; color:gray"><</v-btn>
    </div>
  </div>
</template>

<script>
import store from "@/store"
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            isDark: state => state.util.isDark,
        }),
      contractType: function  () {
           if (this.$route.params.contractType == 'nft') {
             return this.nftContent
           } else if (this.$route.params.contractType == 'token') {
             return this.tokenContent
           } else if (this.$route.params.contractType == 'database') {
             return this.databaseContent
           } else if (this.$route.params.contractType == 'blank') {
             return this.blankContent
           }
      }
    },
    data () {
      return {
        bg: 'black',
        
        template: 
          { icon: '', iconClass: 'grey lighten-1 white--text', title: 'Basic database', subtitle: 'Create your censorship resistant endpoint', route: "contractDetail" },
       
        nftContent: {
          name: 'Digital asset',
          desc: `Digital assets can represent ownership over digital or physical assets: 
            Physical property — houses, unique artwork, 
            unique collectibles,  
            limited-edition collections and  
            anything else.

            NFTs are distinguishable and you must track the ownership of each unit separately.`,
          image: '',
          // usedBy: [ 'http://google.com','http://google.com','http://google.com' ]
        },
        tokenContent: {
          name: 'Token',
          desc: `Enjoy the benefits of tokenizing your business with the Token template. <br/><br/> Create traceable and fully transparent audit trails, trade and build within an internal economy, develop loyalty and rewards systems which benefit you and your users, and fast-track projects by reducing unnecessary steps and dependencies. The role of the native token within your platform is defined only by your vision.`,
          // desc: `for 
          //   audit trails,
          //   Internal economy, 
          //   virtual scarcity, 
          //   reward systems and 
          //   anything else.`,
          image: '../assets/contractTabSelect/token.png',
          features: [ 'Freely exchangeable by nature','Transparent audit trails','Loyalty and rewards mechanisms' ]
        },
        databaseContent: {
          name: 'Database',
          desc: `database to log digital or physical events:

            Physical property — houses, unique artwork
            Cryptocollectibles — unique collectibles or instances which are part of limited-edition collections.
            "Negative value" assets — loans, burdens and other responsibilities
            NFTs are distinguishable and you must track the ownership of each one separately.`,
          image: '',
          // usedBy: [ 'http://google.com','http://google.com','http://google.com' ]
        },
        blankContent: {
          name: 'Blank slate',
          desc: `Upload your own contract and we will help you get it online

            Physical property — houses, unique artwork
            Cryptocollectibles — unique collectibles or instances which are part of limited-edition collections.
            "Negative value" assets — loans, burdens and other responsibilities
            NFTs are distinguishable and you must track the ownership of each one separately.`,
          image: '',
          usedBy: [ 'http://google.com','http://google.com','http://google.com' ]
        }
      }
    },
    created: function () {
      this.contractType = (this.$route.params.contractType)
      if (this.isDark) {
           this.bg = 'black'
      } else {
           this.bg = 'white'
      }
      // console.log(this.nftContent)
    },
    methods: {
      goToDetail(){
        // Fix for new users needing a refresh to trigger being approved in AWS setup
        window.location.assign("../../contractDetail/" + this.$route.params.contractType)
        // this.$router.push({name: 'contractDetail', params: { contractType: this.$route.params.contractType }})
      }
    }
}
</script>


<style>

 

<style>